import React, { createContext, useContext, useState, useEffect, useRef, ReactNode, useMemo } from 'react';
import '../../../App.css';
import { BlueButton, MapContainer } from '../../../assets/style';
import Map from '../../../components/MapsForEntry';
import { useLocation, useNavigate } from 'react-router-dom';
import MainContent from '../../../components/MainContent';
import { Accordion, AccordionDetails, AccordionSummary, Box, CircularProgress, createTheme, CssBaseline, Modal, ScopedCssBaseline, ThemeProvider, } from '@mui/material';
import { alpha } from '@mui/material/styles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import RoomIcon from '@mui/icons-material/Room';
import { format, differenceInSeconds, addSeconds, intervalToDuration, formatDuration, formatDate } from 'date-fns';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import WaterDropOutlinedIcon from '@mui/icons-material/WaterDropOutlined';
import WbCloudyOutlinedIcon from '@mui/icons-material/WbCloudyOutlined';
import ThunderstormOutlinedIcon from '@mui/icons-material/ThunderstormOutlined';
import AirOutlinedIcon from '@mui/icons-material/AirOutlined';
import { ReactComponent as RainFallIcon } from '../../assets/svgs/rainfall.svg';
import { ReactComponent as RainyIcon } from '../../assets/svgs/rainy.svg';
import { camera1Demo, workerIcon, greenlightIcon } from '../../../assets/imgs';
import RecordTable, { TableHeader } from '../../../components/RecordTable';
import type { } from '@mui/x-data-grid/themeAugmentation';
import styled from '@emotion/styled';
import { realTimePageName, schedulePageName } from '../../../components/PageName';
import { useGetWeatherInfoQuery } from '../../../features/weather/WeatherSlice';
import ScannerInput from '../../../components/ScannerInput';
import MediaMtxWebRtcVideo from '../../../components/MediaMtxWebRtcVideo';
import Signalr from '../../../features/SignalR/SignalR';
import { useCountInAIMutation, useCountInMutation, useCountOutAIMutation, useCountOutMutation, useLazyGetScheduleByIdQuery, useLazyGetScheduleByScheduleIdQuery, useScheduleCheckOutMutation, useWorkerCheckInMutation, useWorkerCheckOutMutation } from '../../../features/schedule/scheduleSlice';
import dayjs from 'dayjs';
import { useStartMonitoringMutation, useStopMonitoringMutation } from '../../../features/sensors/sensorsSlice';
import { workerData } from 'worker_threads';
import { margin } from '@mui/system';
import HeartRateHub from '../../../features/SignalR/HeartRate';
import useInOutHub from '../../../features/SignalR/InOutHub';
import BloodOxygenHub from '../../../features/SignalR/BloodOxygen';
import { ZoomControl } from 'react-leaflet';
import { useTranslation } from "react-i18next";
import WatchGPSHub from '../../../features/SignalR/WatchGPS';
import MediaMtxHlsVideo from '../../../components/MediaMtxHlsVideo';
import ZetronHub from '../../../features/SignalR/ZetronHub';
import WorkScheduleHub, { SendDataToWorkScheduleHub } from '../../../features/SignalR/WorkScheduleHub';

export const ContainerDiv = styled.div`
    display: flex;
    @media (max-width: 1040px){
        flex-direction: column;
    }
`
export const MainContainerDiv = styled(ContainerDiv)`
    @media (max-width: 1040px){
        max-width: 500px;
        overflow-y: auto;
    }
`
export const MainScrollableDiv = styled(ContainerDiv)`
    display: contents;
    @media (max-width: 1040px){
        display: block;
        max-height: calc(100vh - 62px); 
        overflow-y: auto;
        scrollbar-width: none;
    }
`

export const ScrollableDiv = styled.div`
    max-height: calc(100vh - 62px); 
    overflow-y: auto;
    scrollbar-width: none;
    @media (max-width: 1040px){
        max-height: max-content;
        overflow-y: clip;
    }
`

export const RightScrollableDiv = styled(ScrollableDiv)`
    margin-left:auto;
    width: 500px;
    @media (max-width: 1040px){
        width: 100%;
    }
`

export const CollapsableDiv = ({ title, children, notExpanded }: { title?: React.ReactNode, children?: React.ReactNode, notExpanded?: boolean }) => {
    return (
        // <Accordion defaultExpanded={!notExpanded} disableGutters sx={{ backgroundColor: alpha("#00143A", 0.8) }}>
        <Accordion defaultExpanded={!notExpanded} disableGutters sx={{ backgroundColor: title ? alpha("#00143A", 0.8) : alpha("#052A70CC", 0.8) }}>
            <AccordionSummary
                expandIcon={<ArrowDropDownIcon />}
                sx={{ margin: '0px', maxHeight: "10px" }} >
                {title}
            </AccordionSummary>
            <AccordionDetails>
                {children}
            </AccordionDetails>
        </Accordion >
    )
}

export const TimedNode = ({ calculateInterval, render }: { calculateInterval: (time: Date) => number, render: (time: Date) => React.ReactNode }) => {
    const [curTime, setCurTime] = useState(new Date())

    setTimeout(() => {
        setCurTime(new Date())
    }, calculateInterval(curTime))

    return <>{render(curTime)}</>
}

export const ModalTrigger = ({ renderTrigger, renderContent }:
    {
        renderTrigger: (open: boolean, setOpen: (open: boolean) => void) => React.ReactNode
        renderContent: (open: boolean, setOpen: (open: boolean) => void) => React.ReactNode
    }) => {
    const [open, setOpen] = useState(false)

    return (
        <>
            {renderTrigger(open, setOpen)}
            <Modal open={open} onClose={(e) => {
                setOpen(false)
            }}>
                <div style={{
                    position: 'absolute', top: '50%', left: '50%',
                    transform: 'translate(-50%, -50%)',
                    display: 'flex', justifyContent: 'center', alignItems: 'center'
                }}>
                    {renderContent(open, setOpen)}
                </div>
            </Modal>
        </>
    )
}

export const buttonStyle: React.CSSProperties = {
    boxShadow: '10px 6px 10px 0px #486DA5 inset, 0px 4px 4px 0px #00000040',
    borderRadius: '5px', backgroundColor: '#5F84BA', color: 'white',
    border: 'none',
    width: '80px',
    height: '30px',
    cursor: 'pointer',
}
export const GreyButtonStyle: React.CSSProperties = {
    boxShadow: '10px 6px 10px 0px #484848 inset, 0px 4px 4px 0px #00000040',
    borderRadius: '5px', backgroundColor: '#5F5F5F', color: 'white',
    border: 'none',
    width: '80px',
    height: '30px',
    cursor: 'pointer',
}

export const defaultTheme = createTheme();
export const theme = createTheme({
    palette: {
        text: {
            primary: "#fff",
        },
        primary: {
            main: '#fff',
        },
    },
    typography: {
        allVariants: {
            fontFamily: 'Poppins',
        },
        body1: {
            fontSize: '20px',
        }
    },
    components: {
        MuiSvgIcon: {
            defaultProps: {
                color: "primary"
            }
        },
        MuiAccordionSummary: {
            styleOverrides: {
                content: {
                    marginTop: '0px',
                    marginBottom: '0px',
                    textDecoration: "underline",
                    fontSize: '22px',
                }
            }
        },
    },
})